import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { formatPhoneNumber, parsePhone } from '@/lib/formatter';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';

import {
  phoneNumber,
  required,
  isCompanyName,
  isDepartmentName,
  isPositionName,
} from '@/lib/rule';


export default /*#__PURE__*/_defineComponent({
  __name: 'InquiryFormEn',
  props: {
    isValidForm: { type: Boolean },
    email: null,
    phone: null,
    department: null,
    position: null,
    firstName: null,
    lastName: null,
    middleName: null,
    companyName: null
  },
  emits: ["update:isValidForm", "update:firstName", "update:lastName", "update:middleName", "update:companyName", "update:email", "update:phone", "update:department", "update:position"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:firstName', data: string): void;
  (e: 'update:lastName', data: string): void;
  (e: 'update:middleName', data: string): void;
  (e: 'update:companyName', data: string): void;
  (e: 'update:email', data: string): void;
  (e: 'update:phone', data: string): void;
  (e: 'update:department', data: string): void;
  (e: 'update:position', data: string): void;
}), expose: any, slots: any, attrs: any }) {



const m = defineMessages({
  email: 'メール',
  lastName: '苗字',
  companyName: '会社名',
  department: '部署 (部署がない場合は "なし" と記入してください)',
  position: '役職 (役職がない場合は "なし" と記入してください)',
  phone: '電話',
});

const formRef = ref(null);



const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateFirstName = (e: string) => {
  emits('update:firstName', e);
};

const updateLastName = (e: string) => {
  emits('update:lastName', e);
};

const updateMiddleName = (e: string) => {
  emits('update:middleName', e);
};

const updateCompanyName = (e: string) => {
  emits('update:companyName', e);
};

const updateEmail = (e: string) => {
  emits('update:email', e);
};

const updatePhone = (e: string) => {
  emits('update:phone', e);
};

const updateDepartment = (e: string) => {
  emits('update:department', e);
};

const updatePosition = (e: string) => {
  emits('update:position', e);
};

onMounted(() => {
  if (formRef.value) {
    formRef.value.validate();
  }
});

return { __sfc: true,m, formRef, emits, updateIsValidForm, updateFirstName, updateLastName, updateMiddleName, updateCompanyName, updateEmail, updatePhone, updateDepartment, updatePosition, formatPhoneNumber, parsePhone, sharedMessages, phoneNumber, required, isCompanyName, isDepartmentName, isPositionName }
}

})